import { Card, CardContent, Grid, Skeleton, Stack } from '@all-manager/design-system-v2';

/** Mirrors a tab of the accounting page (filter, chart card, table card) while it loads. */
export default function AccountingSkeleton() {
  return (
    <Stack spacing={2} aria-busy="true" aria-label="Chargement de la comptabilité">
      <Skeleton variant="rounded" width={160} height={56} />
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 7 }}>
          <Card>
            <CardContent>
              <Stack spacing={2}>
                <Skeleton variant="text" width="50%" />
                <Skeleton variant="rounded" height={280} />
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, md: 5 }}>
          <Card>
            <CardContent>
              <Stack spacing={1}>
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" />
                <Skeleton variant="text" />
                <Skeleton variant="text" />
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Stack>
  );
}
